import { useTitle } from '@flippingbook/web.react-hooks/dist/useTitle';

import { loc } from '@/localization';

import { CancelledPage } from './cancelled';
import { FailedPage } from './failed';
import { SetPage } from './set';
import { StartPage } from './Start';
import { UpdatePage } from './update';

function withTitle(Component: React.ComponentType, title = loc.Login.RestoreTitle) {
    function WithTitle() {
        useTitle(loc.Main.AccountPageTitle.replace('{0}', title));

        return <Component />;
    }
    WithTitle.displayName = `withTitle(${Component.displayName || Component.name})`;

    return WithTitle;
}

export const RestoreStartPage = withTitle(StartPage);
export const RestoreUpdatePage = withTitle(UpdatePage);
export const RestoreFailedPage = withTitle(FailedPage);
export const RestoreCancelledPage = withTitle(CancelledPage);
export const SetPasswordPage = withTitle(SetPage, loc.Login.SetPasswordTitle);
